export const bookingMadeEvent = ({
  event,
  transactionId,
  listingId,
  listingTitle,
  customerId,
  price,
  currency = 'EUR',
  actionType,
}) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      transaction_id: transactionId,
      listing_id: listingId,
      listing_name: listingTitle,
      customer_id: customerId,
      value: price,
      currency,
      action_type: actionType,
    });
  }
};

export const signupMadeEvent = ({ event, customerId, actionType }) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      customer_id: customerId,
      action_type: actionType,
    });
  }
};

export const whatsappMadeEvent = ({ event, customerId, pagePath }) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      customer_id: customerId,
      page_path: pagePath,
    });
  }
};

export const actionTypes = {
  REQUEST_TO_BOOK: 'request_to_book',
  REQUEST_TO_BOOK_AFTER_HOLDING_PERIOD: 'request_to_book_after_holding_period',
  INQUIRY: 'inquiry',
  REQUEST_TO_BOOK_AFTER_INQUIRY: 'request_to_book_after_inquiry',
  REQUEST_TO_SIGNUP: 'request_to_signup',
  SIGNUP_COMPLETED: 'signup_completed',
  REQUEST_TO_BOOK_FORM_SUBMITTED: 'request_to_book_form_submitted',
  REQUEST_A_QUOTE: 'request_a_quote',
  QUOTE_REQUESTED: 'quote_requested',
};
